import { Env } from "../Models/Env";


export class EnvDetector
{
    private readonly env: Env;

    public get Env(): Env
    {
        return this.env;
    }
    
    private DetectEnv(): Env
    {
        if (window.location.origin.includes("localhost"))
            return Env.Stage; // !!!
        else if (["new", "stage", "test"].includes(window.location.origin))
            return Env.Stage;
        else
            return Env.Prod;
    }

    constructor()
    {
        this.env = this.DetectEnv();
        console.log(`Assuming environment is ${this.Env}`);
    }
}
